/**
 * Set the HTML document language attribute
 * @param lang - Language code (en, ja, id, th, vn)
 */
export const setHtmlLang = (lang: string) => {
  // Map internal language codes to standard HTML lang attributes
  const langMap: { [key: string]: string } = {
    en: "en",
    jp: "ja", // Japanese standard is "ja"
    id: "id",
    th: "th",
    vn: "vi", // Vietnamese standard is "vi"
  };

  const htmlLang = langMap[lang] || "en";
  document.documentElement.lang = htmlLang;

  // Also set dir attribute for RTL languages if needed in future
  // For now, all supported languages are LTR
  document.documentElement.dir = "ltr";
};
